import { render, staticRenderFns } from "./ClosedTicketOverview.vue?vue&type=template&id=7bad47cf"
import script from "./ClosedTicketOverview.vue?vue&type=script&lang=js"
export * from "./ClosedTicketOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports